import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_BASE,
  timeout: 15000,
  headers: { 'Content-Type': 'application/json' },
});

// Attach token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('bmo_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Handle 401
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('bmo_token');
      window.location.href = '/login';
    }
    return Promise.reject(err?.response?.data || err);
  }
);

const handle = async (promise) => {
  const res = await promise;
  return res.data;
};

// ── Auth ──────────────────────────────────────────────────────────────────────
export const authApi = {
  login:   (payload) => handle(api.post('/auth/bmo-login', payload)),
  logout:  ()        => { localStorage.removeItem('bmo_token'); },
  profile: ()        => handle(api.get('/auth/me')),
};

// ── BMO Dashboard ─────────────────────────────────────────────────────────────
export const bmoApi = {
  getDashboard:       (params)       => handle(api.get('/bmo/dashboard', { params })),
  getFacilityList:    (params)       => handle(api.get('/bmo/facilities', { params })),
  getFacilityDetail:  (facilityId)   => handle(api.get(`/bmo/facilities/${facilityId}`)),
  compareFacilities:  (facilityIds)  => handle(api.post('/bmo/compare', { facility_ids: facilityIds })),
  getDistrictReport:  (params)       => handle(api.get('/bmo/district-report', { params })),
  getScoreTrend:      (facilityId, params) => handle(api.get(`/bmo/facilities/${facilityId}/score-trend`, { params })),
  getThemeBreakdown:  (facilityId)   => handle(api.get(`/bmo/facilities/${facilityId}/theme-breakdown`)),
  getActivityFeed:    (params)       => handle(api.get('/bmo/activity-feed', { params })),
  getAlerts:          (params)       => handle(api.get('/bmo/alerts', { params })),
  getComplianceMatrix:(params)       => handle(api.get('/bmo/compliance-matrix', { params })),
  getBMWReport:       (params)       => handle(api.get('/bmo/bmw-report', { params })),
  getVaccinationSummary: (params)    => handle(api.get('/bmo/vaccination-summary', { params })),
  getCertificationStatus:(params)    => handle(api.get('/bmo/certification-status', { params })),
  exportReport:       (params)       => handle(api.get('/bmo/export', { params, responseType: 'blob' })),
};

export default api;
